// extracted by mini-css-extract-plugin
module.exports = {"map":"PopupOverlay_map__WY-Bx","wrapper":"PopupOverlay_wrapper__1ro7l","frame-popup":"PopupOverlay_frame-popup__1viM0","section-title":"PopupOverlay_section-title__257ML"};